import React from 'react'
import { SvgIcon } from '../svg-icon'

const defaultProps = {
    viewBoxSize: 48
}

const ChecklistIcon = props => (
    <SvgIcon viewBox="0 0 48 48" {...props}>
        <path
            d={`M38.89,3.16H9.13A4.64,4.64,0,0,0,5,7.94V40.47a4.45,4.45,0,0,0,4.2,4.69H38.8A4.45,4.45,0,0,0,43,
            40.47h0V7.94C43,5.31,41.28,3.16,38.89,3.16Zm0,22.72L34.3,30.52v.06l-.4.32-9.48,9.61a2,2,0,0,1-1.34.57,
            1.88,1.88,0,0,1-1.33-.59L14.5,33.13a1.9,1.9,0,0,1,0-2.7l1.14-1.14a2,2,0,0,1,1.4-.56,1.84,1.84,0,0,1,
            1.32.59l4.72,4.78L35,22a1.94,1.94,0,0,1,1.4-.59,1.9,1.9,0,0,1,1.32.61l1.21,1.23a1.84,1.84,0,0,1,0,2.6l0,
            0ZM35.8,12.76H13.57a2.37,2.37,0,0,1-2.22-2.49,2.37,2.37,0,0,1,2.22-2.49H35.78A2.38,2.38,0,0,1,38,10.28a2.38,
            2.38,0,0,1-2.23,2.5Zm-22.23,9a2.37,2.37,0,0,1-2.22-2.49,2.37,2.37,0,0,1,2.22-2.49H26.36a2.37,2.37,0,0,1,
            2.23,2.5,2.38,2.38,0,0,1-2.23,2.5Z`}
        />
    </SvgIcon>
)

ChecklistIcon.defaultProps = defaultProps

export { ChecklistIcon }
